function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 154 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1576,-780)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.918,217.083C403.79,217.083 411.376,205.589 411.376,195.624C411.376,195.297 411.37,194.972 411.354,194.649C412.827,193.585 414.107,192.256 415.117,190.744C413.766,191.343 412.312,191.748 410.786,191.931C412.343,190.997 413.538,189.52 414.102,187.759C412.645,188.623 411.031,189.252 409.314,189.589C407.937,188.124 405.978,187.207 403.808,187.207C399.642,187.207 396.265,190.584 396.265,194.748C396.265,195.34 396.331,195.916 396.461,196.468C390.193,196.153 384.635,193.151 380.915,188.588C380.268,189.702 379.894,190.997 379.894,192.379C379.894,194.995 381.225,197.305 383.25,198.656C382.013,198.618 380.851,198.278 379.834,197.712L379.832,197.809C379.832,201.462 382.433,204.511 385.883,205.203C385.25,205.375 384.583,205.468 383.896,205.468C383.409,205.468 382.937,205.42 382.477,205.332C383.437,208.329 386.221,210.509 389.522,210.571C386.941,212.593 383.69,213.799 380.155,213.799C379.547,213.799 378.947,213.764 378.357,213.695C381.695,215.834 385.657,217.083 389.918,217.083Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.2bf84e7b037371e0e01c0872c908ec7e.svg";
export { ForwardRef as ReactComponent };